/** @jsx jsx */
import React, { useRef } from 'react';
import { jsx } from '@emotion/core';
import { editButtonStyles, readViewContentWrapperStyles } from './styles';
var DRAG_THRESHOLD = 5;

var ReadView = function ReadView(_ref) {
  var editButtonLabel = _ref.editButtonLabel,
      onEditRequested = _ref.onEditRequested,
      postReadViewClick = _ref.postReadViewClick,
      editButtonRef = _ref.editButtonRef,
      readViewFitContainerWidth = _ref.readViewFitContainerWidth,
      readView = _ref.readView;
  var startX = useRef(0);
  var startY = useRef(0);

  var mouseHasMovedAfterMouseDown = function mouseHasMovedAfterMouseDown(event) {
    return Math.abs(startX.current - event.clientX) >= DRAG_THRESHOLD || Math.abs(startY.current - event.clientY) >= DRAG_THRESHOLD;
  };

  var onReadViewClick = function onReadViewClick(event) {
    var element = event.target;
    /** If a link is clicked in the read view, default action should be taken */

    if (element.tagName.toLowerCase() !== 'a' && !mouseHasMovedAfterMouseDown(event)) {
      event.preventDefault();
      onEditRequested();
      postReadViewClick();
    }
  };
  /* eslint-disable jsx-a11y/click-events-have-key-events,jsx-a11y/no-static-element-interactions,jsx-a11y/no-noninteractive-element-interactions */


  return jsx(React.Fragment, null, jsx("button", {
    css: editButtonStyles,
    "aria-label": editButtonLabel,
    type: "button",
    onClick: onEditRequested,
    ref: editButtonRef
  }), jsx("div", {
    css: readViewContentWrapperStyles,
    onClick: onReadViewClick,
    onMouseDown: function onMouseDown(e) {
      startX.current = e.clientX;
      startY.current = e.clientY;
    },
    "data-read-view-fit-container-width": readViewFitContainerWidth
  }, readView()));
  /* eslint-enable jsx-a11y/click-events-have-key-events,jsx-a11y/no-static-element-interactions,jsx-a11y/no-noninteractive-element-interactions */
};

export default ReadView;